import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const CloseIcon: React.FC<NormalIconProps> = (props) => (
	<svg viewBox="0 0 20 20" fill="#fff" onClick={props.onClick} className={props.className ? props.className : ''}>
		<path
			id="Path_5071"
			data-name="Path 5071"
			d="M10,20A10,10,0,1,1,20,10,10.011,10.011,0,0,1,10,20ZM10,1.429A8.571,8.571,0,1,0,18.571,10,8.581,8.581,0,0,0,10,1.429Zm0,0"
		/>
		<path
			id="Path_5072"
			data-name="Path 5072"
			d="M154.108,154.821a.708.708,0,0,1-.5-.208l-7.11-7.11A.711.711,0,1,1,147.5,146.5l7.11,7.11a.711.711,0,0,1-.5,1.214Zm0,0"
			transform="translate(-140.553 -140.554)"
		/>
		<path
			id="Path_5073"
			data-name="Path 5073"
			d="M147,154.819a.711.711,0,0,1-.5-1.214l7.11-7.11a.711.711,0,0,1,1.005,1.005l-7.11,7.11A.708.708,0,0,1,147,154.819Zm0,0"
			transform="translate(-140.552 -140.553)"
		/>
	</svg>
);
